define('ANSI/Components/Maps/InteractiveMap',['jquery'], function ($) {

    function InteractiveMap(scope) {
        $('path', scope).each(function (i, item) {
            if ($(item).hasClass('selected')) {
                $(item).closest('g').addClass('active');
            }
        });

        $('g', scope).each(function (i, item) {
            if ($(item).hasClass('selected')) {
                $(item).addClass('active');
            }
        });

        // Show popover
        $('g', scope).mouseenter(function (e) {
            if ($(this).hasClass('active')) {
                var region = $(this).attr('id');
                $('.' + region, scope).addClass('showpop');
            }
        });

        //Hide popover
        $('g', scope).mouseleave(function (e) {
            if ($(this).hasClass('active')) {
                var region = $(this).attr('id');
                $('.' + region, scope).removeClass('showpop');
            }
        });

        //Stop the popover from hiding when in it
        $('.score-well', scope).mouseenter(function (e) {
            if ($(this).hasClass('showpop')) {
                e.stopPropagation();
            }
        });
    }

    InteractiveMap.init = function init(args) {
        return args.IsEditorEditing === true ? null : new InteractiveMap(args.scope);
    };

    return InteractiveMap;
});
